import React from 'react'
import { MenuItem } from '@blueprintjs/core'
import { Select2, ItemListPredicate, ItemRendererProps } from '@blueprintjs/select'
import { Button, HighlightedText } from '@ui'
import { IUIButtonProps } from '@ui/buttons/Button'
import fuzzy from 'fuzzaldrin-plus'

export type percentOption = { value: number; display: string }

export const createPercentOptions = (): percentOption[] => {
  const options = []

  // 0 - 100% increasing by 5
  for (let i = 0; i <= 100; i += 5) {
    const option: percentOption = { value: i, display: `${i}%` }
    options.push(option)
  }

  return options
}

export default function PercentSelector({
  value,
  onChange,
  buttonProps,
}: {
  value: number
  onChange: (item: percentOption) => void
  buttonProps?: IUIButtonProps
}) {
  if (!value && value !== 0) return null

  const PercentSelect = Select2<percentOption>

  const items = createPercentOptions()

  return (
    <PercentSelect
      onItemSelect={(item) => onChange(item)}
      popoverProps={{ minimal: true, position: 'bottom' }}
      items={items}
      itemListPredicate={filterTitles}
      itemRenderer={PercentRenderer}
    >
      <Button {...buttonProps} text={`${value}%`} />
    </PercentSelect>
  )
}

function PercentRenderer(
  item: percentOption,
  { handleClick, modifiers, query }: ItemRendererProps
) {
  return (
    <MenuItem
      key={item.value}
      active={modifiers.active}
      disabled={modifiers.disabled}
      onClick={handleClick}
      text={
        <div className="flex items-center">
          <HighlightedText text={item.display} query={query} />
        </div>
      }
    />
  )
}

const filterTitles: ItemListPredicate<percentOption> = (query, items) => {
  return query ? fuzzy.filter(items, query, { key: 'display' }) : items
}
